(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-pack-picker"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('pack-cards')) return;

    /**
     * Keeps the bundle rows and the gift row honest. The Pack option is still a normal
     * radio group inside <variant-picker>, so VariantPicker handles selection, the URL,
     * the hidden id input and variant:change. This element only recomputes what each
     * row displays for the current Flavor mix (assets/rooted-pack.js), and flips the
     * free gift row between locked and unlocked.
     */
    class PackCards extends HTMLElement {
      connectedCallback() {
        this.picker = this.closest('variant-picker');
        if (!this.picker) return;
        this._onVariantChange = () => this.update();
        this.picker.addEventListener('variant:change', this._onVariantChange);

        // A locked gift row is a shortcut: it selects the first qualifying pack.
        this.gift = this.querySelector('[data-pack-gift]');
        if (this.gift) {
          this._onGiftClick = () => this.unlockGift();
          this.gift.addEventListener('click', this._onGiftClick);
        }
      }

      disconnectedCallback() {
        if (this.picker) this.picker.removeEventListener('variant:change', this._onVariantChange);
        if (this.gift && this._onGiftClick) this.gift.removeEventListener('click', this._onGiftClick);
      }

      get packInputs() {
        return Array.from(this.querySelectorAll('.variant-picker__option input[type="radio"]'));
      }

      unlockGift() {
        const pack = window.RootedPack;
        if (!pack || !this.gift || this.gift.dataset.state !== 'locked') return;
        const inputs = this.packInputs;
        const target = pack.giftTarget(this.dataset.giftPacks, inputs.map((input) => input.value));
        const input = inputs.find((candidate) => candidate.value === target);
        if (!input || input.checked) return;
        input.checked = true;
        // VariantPicker listens for change on the <variant-picker> element.
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      updateGift(selected) {
        const pack = window.RootedPack;
        if (!pack || !this.gift) return;
        const index = parseInt(this.dataset.packIndex, 10);
        this.gift.dataset.state = pack.giftState(selected[index], this.dataset.giftPacks);
      }

      // Swap every row's thumbnail to the box shot for the selected Flavor mix.
      updateThumbs(selected) {
        const pack = window.RootedPack;
        if (!pack || !pack.tierThumbKey) return;
        let map = {};
        try { map = JSON.parse(this.dataset.thumbMap || '{}'); } catch (e) { map = {}; }
        const mix = selected[parseInt(this.dataset.mixIndex, 10)];
        this.querySelectorAll('[data-pack-value]').forEach((row) => {
          const img = row.querySelector('[data-pack-thumb]');
          const url = map[pack.tierThumbKey(row.dataset.packValue, mix)];
          if (img && url && img.getAttribute('src') !== url) img.setAttribute('src', url);
        });
      }

      update() {
        const pack = window.RootedPack;
        if (!pack) return;
        const selected = this.picker.selectedOptions;
        this.updateGift(selected);
        this.updateThumbs(selected);
        if (!this.picker.variants) return;

        let base = [];
        try { base = JSON.parse(this.dataset.baseOptions || '[]'); } catch (e) { base = []; }
        const cfg = {
          packIndex: parseInt(this.dataset.packIndex, 10),
          boxesMap: this.dataset.boxesMap,
          bagsPerBox: parseInt(this.dataset.bags, 10) || 12,
          baseOptions: base
        };
        const money = window.MasterTheme && window.MasterTheme.formatMoney;
        if (!money) return;

        this.querySelectorAll('[data-pack-value]').forEach((row) => {
          const figures = pack.cardFigures(this.picker.variants, cfg, row.dataset.packValue, selected);
          if (!figures) return;
          const price = row.querySelector('[data-pack-price]');
          const compare = row.querySelector('[data-pack-compare]');
          const cup = row.querySelector('[data-pack-cup]');
          const save = row.querySelector('[data-pack-save]');
          if (price) price.textContent = money(figures.priceCents);
          if (compare) {
            compare.textContent = figures.compareCents > 0 ? money(figures.compareCents) : '';
            compare.hidden = figures.compareCents <= 0;
          }
          if (cup) cup.textContent = (this.dataset.cupTemplate || '').replace('__PRICE__', money(figures.perCupCents));
          if (save) {
            save.textContent = (this.dataset.saveTemplate || '').replace('__PERCENT__', figures.savePercent);
            save.hidden = figures.savePercent <= 0;
          }
        });
      }
    }
    customElements.define('pack-cards', PackCards);

    // Mint note (rendered by sections/main-product.liquid): shown while the
    // selected variant contains mint.
    document.addEventListener('variant:change', (event) => {
      const variant = event.detail && event.detail.variant;
      const pack = window.RootedPack;
      if (!pack) return;
      document.querySelectorAll('[data-mint-note]').forEach((note) => {
        note.hidden = !(variant && pack.showsMint(variant.options));
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
